import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPoint, AdminNavEntryPointV2 } from '@retailer-platform/dashboard/routing'
import { featureEntitlementsManagementAdminRouter } from './routing/featureEntitlementsManagementAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { FeatureEntitlementManagementAccessConfig } from './access-control/featureEntitlementsManagementAdminAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'feature-entitlements-management',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'feature-entitlements-management-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    admin: [featureEntitlementsManagementAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachTo: AdminNavEntryPoint.RetailerManagement,
      attachToV2: AdminNavEntryPointV2.UserMenu,
      subNavItems: [
        {
          route: 'app-admin-feature-entitlements-management-entitlements',
          labelId: 'featureEntitlementsManagementDomain.title',
          accessControl: FeatureEntitlementManagementAccessConfig,
          positionNavV2: 1,
        },
      ],
    },
  ],
}

export default definition
